import { ReviewSearchParamsDto } from '@/contracts/marketplace/reviews';
import { BrandGroupEntity } from '@/entities/brand-group.entity';
import { ProductGroupEntity } from '@/entities/product-group.entity';
import { ReviewEntity } from '@/entities/review.entity';
import { useReviewsPageState } from '@/context/use-reviews-page-state';
import { useReviewsPageProviderConnections } from '@/context/use-reviews-page-provider-connections';
import { buildReviewsPageProviderValue } from '@/context/reviews-page-provider-value.builder';
import { buildReviewsPageProviderBindings } from '@/context/reviews-page-provider-bindings.builder';

type UseReviewsPageProviderValueArgs = {
    totalReviews: number;
    reviews: ReviewEntity[];
    products: ProductGroupEntity[];
    brandGroups: BrandGroupEntity[];
    filters: ReviewSearchParamsDto;
    reviewsOnPage: number;
    maxSelectedItems: number | null;
};

export const useReviewsPageProviderValue = ({
    totalReviews,
    reviews,
    products,
    brandGroups,
    filters,
    reviewsOnPage,
    maxSelectedItems,
}: UseReviewsPageProviderValueArgs) => {
    const { state, ...actions } = useReviewsPageState({
        totalReviews,
        reviews,
        products,
        brandGroups,
        filters,
        reviewsOnPage,
    });

    const connections = useReviewsPageProviderConnections({
        selectionSessionId: state.selectionSessionId,
        pickedProducts: state.pickedProducts,
        pickedBrandGroups: state.pickedBrandGroups,
        products: state.products,
        brandGroups: state.brandGroups,
        reviewsOnPage: state.reviewsOnPage,
        filtersQuery: state.filtersQuery,
        sort: state.sort,
        selectionReconcileRevision: state.selectionReconcileRevision,
        setSelectionSessionId: actions.setSelectionSessionId,
        setPickedReviews: actions.setPickedReviews,
        setPickedProducts: actions.setPickedProducts,
        setPickedBrandGroups: actions.setPickedBrandGroups,
        setProductsState: actions.setProductsState,
        setBrandGroupsState: actions.setBrandGroupsState,
        setReviewsAndTotalState: actions.setReviewsAndTotalState,
        setReviewsOnPageState: actions.setReviewsOnPageState,
        onReviewAnswerJobDone: actions.applyReviewAnswerJobDone,
        onReviewFeedItemChanged: actions.applyReviewFeedItemChanged,
    });

    return buildReviewsPageProviderValue(
        buildReviewsPageProviderBindings({
            state,
            actions,
            connections,
            maxSelectedItems,
        }),
    );
};
